<template>
  <div
    v-if="attachmentOptions && attachmentOptions.length"
    class="file-uploaded"
  >
    <div class="file clickable flex-row flex__between padding-left-10">
      <a
        class="flex-row flex__left"
        @click="downloadDoc(attachmentOptions[0].attachment)"
      >
        <fileTypeImage
          :fileExtention="attachmentOptions[0].attachment.fileExtention"
        />
        <span class="fileName font-weight_normal">{{
            attachmentOptions[0].label
          }}</span>
      </a>
      <a
        class="clickable icon-download-file margin-right-10"
        @click="downloadDoc(attachmentOptions[0].attachment)"
      >
        <i class="fas fa-cloud-download color__white font-size__medium"></i>
      </a>
      <div v-if="attachmentOptions.length > 1" class="dropdown-file">
        <el-dropdown
          class="dropdown-file-icon flex-row flex__center"
          trigger="hover"
        >
          <div class="el-dropdown-link width__100 flex-row flex__between">
            <i
              class="el-icon-caret-bottom el-icon--right margin-right-10 padding-right-10"
            ></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item class="clearfix">
              Danh sách file
            </el-dropdown-item>
            <el-dropdown-item
              v-for="(attachmentOption, index) in attachmentOptions"
              v-if="index > 0"
              :key="attachmentOption.type"
              class="clearfix flex-row flex__left"
            >
              <div class="margin-right-5">{{ index }}.&nbsp;</div>
              <div class="file-uploaded style-fullWidth">
                <div
                  class="file clickable flex-row flex__between padding-left-10 style-fullWidth"
                  @click="downloadDoc(attachmentOption.attachment)"
                >
                  <a class="file-name flex-row flex__left">
                    <file-type-image
                      :fileExtention="attachmentOption.attachment.fileExtention"
                    />
                    <span class="fileName font-weight_normal">{{
                        attachmentOption.label
                      }}</span>
                  </a>
                  <a
                    class="clickable icon-download-file margin-right-10 flex__right"
                  >
                    <i
                      class="fas fa-cloud-download color__white font-size__medium"
                    ></i>
                  </a>
                </div>
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import attachmentService from "../../services/attachmentService";
import downloadService from "../../services/downloadService";
import h from "../../services/h";
import constants from "../../constants";
import userDeptRoleViewService from "../../services/userDeptRoleViewService";
import FileTypeImage from "../job/FileTypeImage";
import errorMessageFilter from "../../filters/errorMessageFilter";
import authenService from "../../services/authenService";
import Vue from "vue";
import vbAttachmentTokenService from "../../services/vbAttachmentTokenService";
import buildAttachmentURL from "../../filters/buildAttachmentURL.js";

export default {
  name: "vbdi-download-files",
  components: {FileTypeImage},
  props: ["userDeptRoleId", "docId"],
  data() {
    return {
      userDeptRole: null,
      attachmentOptions: null
    };
  },

  computed: {
    globalConfigEditNode(){
      return authenService.getGlobalConfigEditNode()
    },
  },

  watch: {
    docId() {
      this.loadUserDeptRole().then(() => this.initAttachment());
    }
  },

  created() {
    this.loadUserDeptRole().then(() => this.initAttachment());
  },

  methods: {
    loadUserDeptRole() {
      return userDeptRoleViewService
        .findById(this.userDeptRoleId)
        .then(response => (this.userDeptRole = response.data));
    },

    initAttachment() {
      let attachmentTypes = null;
      if (this.userDeptRole.roleCode === constants.ROLE.CODE.VAN_THU) {
        attachmentTypes = [
          constants.ATTACHMENT_OBJECT_TYPE.VB_DI,
          constants.ATTACHMENT_OBJECT_TYPE.VB_DI_SIGNED_WITH_TOKEN,
          constants.ATTACHMENT_OBJECT_TYPE.VB_DI_REFERENCE_ATTACHMENT,
          constants.ATTACHMENT_OBJECT_TYPE.VB_DI_SIGNED_WITH_TOKEN_WITHOUT_STAMP
        ];

        Promise.all(
          h.collect(attachmentTypes, attachmentType =>
            this.loadAttachment(attachmentType)
          )
        ).then(results => {
          let vbDiAttachment = results[0];
          let vbDiWithTokenAttachment = results[1];
          let vbDiReferenceAttachment = results[2];
          let vbDiWithTokenWithoutStampAttachment = results[3];

          this.attachmentOptions = [];
          if (vbDiReferenceAttachment)
            this.attachmentOptions.push({
              type: vbDiReferenceAttachment.objectType,
              attachment: vbDiReferenceAttachment,
              label: errorMessageFilter({
                errorCode: "vbAttachment.objectType.vbDiReference"
              })
            });
          if (vbDiWithTokenAttachment)
            this.attachmentOptions.push({
              type: vbDiWithTokenAttachment.objectType,
              attachment: vbDiWithTokenAttachment,
              label: errorMessageFilter({
                errorCode: "vbAttachment.objectType.vbDiSingWithToken"
              })
            });
          if (vbDiWithTokenWithoutStampAttachment)
            this.attachmentOptions.push({
              type: vbDiWithTokenWithoutStampAttachment.objectType,
              attachment: vbDiWithTokenWithoutStampAttachment,
              label: errorMessageFilter({
                errorCode:
                  "vbAttachment.objectType.vbDiSingWithTokenWithoutStamp"
              })
            });
          this.attachmentOptions.push({
            type: vbDiAttachment.objectType,
            attachment: vbDiAttachment,
            label: errorMessageFilter({
              errorCode: "vbAttachment.objectType.vbDi"
            })
          });
        });
      } else {
        attachmentTypes = [
          constants.ATTACHMENT_OBJECT_TYPE.VB_DI,
          constants.ATTACHMENT_OBJECT_TYPE.VB_DI_REFERENCE_ATTACHMENT
        ];

        Promise.all(
          h.collect(attachmentTypes, attachmentType =>
            this.loadAttachment(attachmentType)
          )
        ).then(results => {
          let vbDiAttachment = results[0];
          let vbDiReferenceAttachment = results[1];

          this.attachmentOptions = [];
          if (vbDiReferenceAttachment)
            this.attachmentOptions.push({
              type: vbDiReferenceAttachment.objectType,
              attachment: vbDiReferenceAttachment,
              label: errorMessageFilter({
                errorCode: "vbAttachment.objectType.vbDiCommon"
              })
            });
          else
            this.attachmentOptions.push({
              type: vbDiAttachment.objectType,
              attachment: vbDiAttachment,
              label: errorMessageFilter({
                errorCode: "vbAttachment.objectType.vbDiCommon"
              })
            });
        });
      }
    },

    loadAttachment(objectType) {
      if(this.globalConfigEditNode)
      {
        if(objectType === constants.ATTACHMENT_OBJECT_TYPE.VB_DI)
        {
          return attachmentService
            .findLatestVbAttachmentPdfByDoc(this.docId)
            .then(response => {
              if (response.data) {
                return response.data;
              }
            });
        }
        else {
          return attachmentService
            .findAll({
              objectId: this.docId,
              objectType: objectType
            })
            .then(response => {
              if (response.data && response.data.length) {
                return response.data[0];
              }
            });

        }
      }
      else {
        return attachmentService
          .findAll({
            objectId: this.docId,
            objectType: objectType
          })
          .then(response => {
            if (response.data && response.data.length) {
              return response.data[0];
            }
          });

      }
    },

    downloadDocLanhDaoEdit(attachment) {
      if (attachment) {
        downloadService.downloadOutgoingDoc(attachment.objectId);
      }
    },

    downloadDoc(attachment) {
      const ext = attachment.fileExtention.toLowerCase();

      // Kiểm tra phần mở rộng của tệp
      if (ext === constants.DOWNLOAD_OPTION.TYPE.DOC || ext === constants.DOWNLOAD_OPTION.TYPE.DOCX) {
        this.openDocument(attachment);
      } else {
        switch (attachment.objectType) {
          case constants.ATTACHMENT_OBJECT_TYPE.VB_DI_REFERENCE_ATTACHMENT:
            return this.userDeptRole.roleCode === constants.ROLE.CODE.VAN_THU
              ? downloadService.downloadReferenceOutgoingDocForVT(attachment.objectId)
              : downloadService.downloadReferenceOutgoingDoc(attachment.objectId);

          case constants.ATTACHMENT_OBJECT_TYPE.VB_DI:
            if (this.globalConfigEditNode) {
              return this.userDeptRole.roleCode === constants.ROLE.CODE.VAN_THU
                ? downloadService.downloadOutgoingDocVTLanhDaoEdit(attachment.objectId)
                : downloadService.downloadOutgoingDocLanhDaoEdit(attachment.objectId);
            } else {
              return this.userDeptRole.roleCode === constants.ROLE.CODE.VAN_THU
                ? downloadService.downloadOutgoingDocVT(attachment.objectId)
                : downloadService.downloadOutgoingDoc(attachment.objectId);
            }

          case constants.ATTACHMENT_OBJECT_TYPE.VB_DI_SIGNED_WITH_TOKEN:
          case constants.ATTACHMENT_OBJECT_TYPE.VB_DI_SIGNED_WITH_TOKEN_WITHOUT_STAMP:
            return this.userDeptRole.roleCode === constants.ROLE.CODE.VAN_THU
              ? downloadService.downloadOutgoingDocWithTokenVT(attachment.objectId, attachment.objectType)
              : downloadService.downloadOutgoingDocWithToken(attachment.objectId, attachment.objectType);

          default:
            console.warn('Loại tệp đính kèm không hợp lệ:', attachment.objectType);
            break;
        }
      }
    },

    async openDocument(attachment) {
      const ext = attachment.fileName.split('.').pop().toLowerCase();

      if (ext === 'doc' || ext === 'docx') {
        try {
          let token = this.getToken(attachment.id);

          if (!token) {
            token = await this.waitForToken(attachment.id);
          }

          if (token) {
            const url = buildAttachmentURL(token, {
              type: constants.DOWNLOAD_OPTION.TYPE.ORIGINAL
            });
            window.open(url, '_blank');
          } else {
            console.error("Token is null or undefined.");
          }
        } catch (error) {
          console.error("Error fetching token:", error);
        }
      } else if (ext === 'pdf') {
        this.isOpenNoteInDocDialog = true;
      }
    },

    // Phương thức chờ token
    async waitForToken(vbAttachmentId) {
      return new Promise((resolve, reject) => {
        const checkToken = () => {
          const token = this.getToken(vbAttachmentId);
          if (token) {
            resolve(token);
          } else {
            setTimeout(checkToken, 100);
          }
        };

        checkToken();
      });
    },

    getToken(vbAttachmentId) {
      // console.log('vbAttachmentIdsss', vbAttachmentId)

      if (!vbAttachmentId || !vbAttachmentId.length) return null;

      (!this.vbAttachmentsState) && (this.vbAttachmentsState = {});

      let vbAttachmentState = this.vbAttachmentsState[vbAttachmentId];

      if (!vbAttachmentState || !vbAttachmentState.already) {
        if (!vbAttachmentState) {

          Vue.set(this.vbAttachmentsState, vbAttachmentId, vbAttachmentState = {
            vbAttachmentId: vbAttachmentId,
            already: false
          });

          vbAttachmentTokenService
            .getToken(vbAttachmentId)
            .then(response => {
              vbAttachmentState.token = response.data.token;
              vbAttachmentState.already = true;
            })
        }
        return null;
      } else {
        return vbAttachmentState.token;
      }
    },

  }
};
</script>

<style scoped>
.file-uploaded .file-name {
  width: calc(100% - 42px);
  flex: 0 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-out/vbdi-download-files.vue